import { CurrencySelect } from "@/components/data-driven-inputs/selects/currency-select/CurrencySelect";
import { NegotiationYearSelect } from "@/components/data-driven-inputs/selects/negotiation-year-select/NegotiationYearSelect";
import { SpaceValues } from "@/lib/utils/SpaceValues";
import { ZIndex } from "@/lib/utils/ZIndexEnum";
import { useStatisticsYearSelect } from "@/features/statistics/hooks/UseStatisticsYearSelector";
import { Space } from "@stenajs-webui/core";
import { BreadCrumbs, stenaStatisticsBar } from "@stenajs-webui/elements";
import * as React from "react";
import { Crumb } from "@/components/bread-crumbs/Crumb";
import { PageHeader } from "@/components/page-header/PageHeader";
import { routeFactory } from "../../../RouteFactory";

interface Props {
  customerId: string;
  customerName: string;
  currency: string;
  handleCurrencyChange: (currency: string) => void;
}

export const StatisticsByCustomerDetailsHeader: React.FC<Props> = ({
  customerId,
  customerName,
  currency,
  handleCurrencyChange,
}) => {
  const { year, handleYearChange } = useStatisticsYearSelect();

  const onSelectCurrencyChange = (currency: string) => {
    handleCurrencyChange(currency);
  };

  return (
    <PageHeader
      zIndex={ZIndex.low}
      title={`${customerName} (${customerId})`}
      icon={stenaStatisticsBar}
      breadcrumbs={
        <BreadCrumbs>
          <Crumb
            label={"statistics"}
            path={routeFactory.statistics.totalTab()}
          />
          <Crumb
            label={"Customer"}
            path={routeFactory.statistics.customerTab()}
          />
          <Crumb label={customerName} />
        </BreadCrumbs>
      }
      contentRight={
        <>
          <NegotiationYearSelect
            value={year}
            onValueChange={(value) => handleYearChange(value)}
          />
          <Space num={SpaceValues.SIXTEEN} />
          <CurrencySelect
            value={currency}
            onValueChange={onSelectCurrencyChange}
            containerWidth={"80px"}
          />
        </>
      }
    />
  );
};
